import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import {  MatDialogRef,  MAT_DIALOG_DATA,  MatDialog,} from "@angular/material/dialog";
import { merge, Observable, of, Subject } from "rxjs";
import {  debounceTime,  filter,  map,  startWith,  switchMap,  takeUntil,  tap,} from "rxjs/operators";
import { ConfirmShipmentPayload, CreateDraftShipmentPayload, ShipmentPlan, ShipmentSku } from "src/app/models/shipyard.model";
import { HeaderService } from "src/app/components/header/header.service";
import { AddSkuDialogComponent } from "src/app/components/dialogs/add-sku-dialog/add-sku-dialog.component";
import { SettingsService } from "src/app/services/settings.service";
import { LoginModel } from "src/app/models/login.model";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { ConfirmDialogComponent } from "src/app/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ShipyardService } from "../../shipyard.service";
import { AddSkuToShipmentComponent } from "../add-sku-to-shipment/add-sku-to-shipment.component";
import { GridActionsService } from "../../../../data-grid/grid-actions.service";
import { ShipmentDetail } from "./../../../../models/shipyard.model";
import {SnackbarComponent} from '../../../../components/snackbar/snackbar.component';

@Component({
  selector: "app-plan-shipment-dialog",
  templateUrl: "./plan-shipment-dialog.component.html",
  styleUrls: ["./plan-shipment-dialog.component.scss"],
})
export class PlanShipmentDialogComponent implements OnInit, OnDestroy {
  actions = [];
  isDraft:boolean = true;
  shipmentPlan: ShipmentPlan[];
  filteredOptionsArray: any[] = [];
  isFormValid;
  loading: Subject<boolean> = new Subject();
  account;
  warehouseExists:boolean = true;
  skusToAddToShipment: any[] = [];
  selectedSKUs: ShipmentSku[] = [];
  lastWhUser;
  fbaTypes = this.shipyardService.getAllShipmentTypes();
  private destroy$ = new Subject<void>();
  description = `
      <div>
          <ol type="1">
            <li>
              1. Press 'Plan' on any item to get an FBA destination proposal.
            </li>
            <li>
              2. Once satisfied with location, select the plan and press 'Create
              And Add' which will add all of the selected items into that ID.
            </li>
          </ol>
          <span>
          <b>Note: As per amazon policy, all corresponding proposals must be created and used</b>
          </span
          >
        </div>`;

  get skus() {
    return this.planShipmentForm.get("skus") as FormArray;
  }
  public planShipmentForm: FormGroup = new FormGroup({
    ShipmentType: new FormControl(0, Validators.required),
    fromWareHouseId: new FormControl(null, Validators.required),
    skus: new FormArray([]),
  });
  searchInput: FormControl = new FormControl();
  addToShipmentSkus$: Observable<any> = new Observable();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PlanShipmentDialogComponent>,
    private shipyardService: ShipyardService,
    private router: Router,
    private headerService: HeaderService,
    private snackBar: MatSnackBar,
    public gridActionsService: GridActionsService,
    private cdr: ChangeDetectorRef,
    private settingService: SettingsService
  ) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e));
    this.settingService
      .GetLastUsedWarehouse(this.account[0])
      .pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        if (res) this.lastWhUser = res;
      });
  }

  ngOnInit(): void {
    if (this.data.isDraft) {
      this.actions.push(
        {
          text: "Save as Draft",
          isDisabled: !this.planShipmentForm.valid,
          buttonStyle: "underline",
        },
        { text: "Add to Existing Draft" }
      );
      const shipmentTypeControl = this.planShipmentForm.get("ShipmentType");
      if (this.shipyardService.shipmentTypeToAddToShipment || this.data.shipmentTypeId) {
        shipmentTypeControl.setValue(this.shipyardService.shipmentTypeToAddToShipment ? 
        this.shipyardService.getShipmentTypeId(this.shipyardService.shipmentTypeToAddToShipment) :
        this.data.shipmentTypeId
      );
        shipmentTypeControl.disable();
      }        
      this.selectedSKUs = this.data.selectedSkus ? this.data.selectedSkus : [];
    } else {
      this.addSkuToForm(0);
      this.actions.push(
        { text: "Cancel", buttonStyle: "underline" },
        { text: "Plan Shipment", isDisabled: !this.planShipmentForm.valid }
      );
    }
    this.isFormValid = merge(this.planShipmentForm.statusChanges, this.loading)
      .pipe(map((e) => (e === "VALID" ? false : true)))
      .subscribe((e) => {
        if (!e) {
          if (this.skusToAddToShipment.length !=0 || (this.data.selectedSkus &&  this.data.selectedSkus?.length != 0)) {
            this.actions[1].isDisabled = false;
            this.planShipmentForm.get('ShipmentType').disable();
          }
         else {
            this.actions[1].isDisabled = true;
        }
      }else{
        this.actions[1].isDisabled = true;
      }
      });
    this.data.warehouses$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (result && result.length >= 1) {
        if (
          this.lastWhUser &&
          result.findIndex((res) => res.id == this.lastWhUser) != -1
        )
          this.planShipmentForm
            .get("fromWareHouseId")
            .setValue(this.lastWhUser);
        else
          this.planShipmentForm.get("fromWareHouseId").setValue(result[0].id);
      }
      if (result === null || result.length === 0) {
        this.warehouseExists = false;
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'No Warehouse exist, please create one',
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
      }
    });
   
    this.skusToAddToShipment = this.shipyardService.skusToAddToShipment;
    if (this.data.selectedSkus) {
      this.skusToAddToShipment.forEach((item) => {
        this.data.selectedSkus.map((data) => {
          if (data.sku === item.sku.Sku) {
            item.qty = item.qty + data.qty;
          }
        });
      });
    }
    if(this.skusToAddToShipment.length!=0)
    this.selectedSKUs = this.data.selectedSkus
      ? this.data.selectedSkus.filter((a) =>
          this.skusToAddToShipment.some((b) => b.sku.Sku !== a.sku)
        )
      : [];

      this.planShipmentForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res) => {
        if (this.planShipmentForm.valid && this.data.isDraft) {
          this.actions[0].isDisabled = this.skusToAddToShipment.length ==0 && (this.selectedSKUs?.length ==0) || this.planShipmentForm.invalid
        }
      });
  

    this.setSearch();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  addSkuToForm(index) {
    const group = new FormGroup({
      sku: new FormControl("", Validators.required),
      qty: new FormControl("", [Validators.min(1), Validators.required]),
    });

    this.skus.push(group);
    this.manageSkuAutocomplete(index);
  }

  removeSkuToForm(index) {
    this.skus.removeAt(index);
  }

  dialogAction(e) {
    if (e === "Plan Shipment") {
      this.loading.next(true);
      this.planShipment();
    } else if (e === "Save as Draft") {
      this.createDraft();
    } else if (e === "Replan") {
      this.shipmentPlan = null;
      this.actions = [
        { text: "Cancel", buttonStyle: "underline" },
        { text: "Plan Shipment", isDisabled: !this.planShipmentForm.valid },
      ];
    } else if (e === "Confirm" && this.shipmentPlan) {
      this.loading.next(true);
      this.confirmShipmentPlan();
    } else if (e === "Cancel") {
      this.dialogRef.close();
    } else if (e === "Add to Existing Draft") {
      this.checkShipyardAccess();
    }
  }

  checkShipyardAccess() {
    const user: LoginModel = JSON.parse(localStorage.getItem(StorageKeyEnum.User));
    if (user.isShipyard === 1) {
      if (user.freemiumAvail) {
        this.dialog.open(ConfirmDialogComponent, {
          width: "400px",
          data: {
            title: "Use freemium credit",
            message: "a freemium credit will be used when adding to an existing shipment, Do you want to proceed?",
          }
        }).afterClosed().subscribe((e) => {
          if (e === "Confirm") {
            this.mergeShipment();
          } else {
            return false;
          }
        });
      }
    } else if(user.isShipyard === 2) {
      this.mergeShipment();
    }
  };
  
  close() {
    this.skusToAddToShipment= [];
    this.dialogRef.close();
  }

  manageSkuAutocomplete(index: number) {
    this.filteredOptionsArray[index] = [];
    this.filteredOptionsArray[index] = this.skus.at(index).valueChanges.pipe(
      map((e) => e.sku),
      debounceTime(300),
      switchMap((value) => {
        return this.shipyardService
          .TypeaheadSku(
            this.account[0],
            value,
            this.planShipmentForm.value.ShipmentType
          )
          .pipe(
            tap((obj: any[]) => {
              if (
                obj.length === 0 &&
                this.planShipmentForm.get(`skus.${index}.sku`)
              ) {
                this.planShipmentForm.get(`skus.${index}.sku`).markAsTouched();
                this.planShipmentForm
                  .get(`skus.${index}.sku`)
                  .setErrors({ incorrect: true });
              }
            })
          );
      })
    );
  }

  createDraft() {
    const skusToAddToShipment = this.shipyardService.skusToAddToShipment.map(
      (e) => {
        return {
          sku: e.sku.Sku,
          qty: e.qty,
        };
      }
    );
    this.data.selectedSkus?.map((data) => {
      let selecedSkusToAddToShipment = {
        sku: data.sku,
        qty: data.qty,
      };
      skusToAddToShipment.push(selecedSkusToAddToShipment);
    });
    const payload: CreateDraftShipmentPayload = {
      account: this.account[0],
      shipmentName:'',
      shipmentType: this.planShipmentForm.getRawValue().ShipmentType,
      fromWarehouse: this.planShipmentForm.value.fromWareHouseId.Id,
      skus: skusToAddToShipment,
      isQueue: false
    };
      this.shipyardService
      .CreateShipmentDraft(payload)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (e:ShipmentDetail) => {
          this.dialogRef.close();
          this.shipyardService.skusToAddToShipment = [];
          this.router.navigate([
            "shipyard/shipments/detail/" + e.shipmentHeaderId,
          ]);
        },
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
       }
     });
  }

  planShipment() {
    this.actions[1].spin = true;
    const formValue = {
      ...this.planShipmentForm.value,
      ShipmentType: +this.planShipmentForm.value.ShipmentType,
      fromWareHouseId: this.planShipmentForm.value.fromWareHouseId,
    };
    this.shipyardService.PlanShip(formValue).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e: { errors: any[]; shipmentPlans: ShipmentPlan[] }) => {
        this.actions[1].spin = false;
        if (e.errors.length) {
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                horizontalPosition: 'center',
                data: {
                  title: e.errors.map((e) => `${e.sku}: ${e.reason}`).join("A"),
                  action: 'Dismiss',
                  type: 'error',
                },
              }
          );
        } else if (e.shipmentPlans?.length) {
          this.loading.next(false);
          this.actions = [
            { text: "Replan", buttonStyle: "underline" },
            { text: "Confirm" },
          ];
          this.shipmentPlan = e.shipmentPlans;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                horizontalPosition: 'center',
                data: {
                  title: 'An unknown error occurred. please try again.',
                  action: 'Dismiss',
                  type: 'error',
                },
              }
          );
        }
      },
     error: (err) => {
      this.loading.next(false);
      this.actions[1].spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            horizontalPosition: 'center',
            data: {
              title: err.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
     }
   });
  }

  mergeShipment(plan: any = null) {
    const skusToAddToShipment = this.shipyardService.skusToAddToShipment.map(
      (e) => {
        return {
          sku: e.sku.Sku,
          qty: e.qty,
        };
      }
    );
    this.data.selectedSkus?.map((data) => {
      let selecedSkusToAddToShipment = {
        sku: data.sku,
        qty: data.qty,
      };
      skusToAddToShipment.push(selecedSkusToAddToShipment);
    });
    const shipment = {
      shipmentHeaderId: "",
      shipmentTypeId: this.planShipmentForm.getRawValue().ShipmentType,
      fromWareHouseId: this.planShipmentForm.value.fromWareHouseId,
      skus: skusToAddToShipment,
    };
    this.close();
    this.dialog
      .open(AddSkuToShipmentComponent, {
        width: "720px",
        panelClass: "create-shipment",
        data: { shipment: shipment, selectedSku: this.selectedSKUs },
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {});
  }

  confirmShipmentPlan() {
    const payload: ConfirmShipmentPayload = {
      shipmentPlanHeaderId: this.shipmentPlan[0].shipmentPlanHeaderId,
    
     
    };
    this.shipyardService.ConfirmShipment(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e:any) => {
        this.loading.next(false);
        this.dialogRef.close();
        this.router.navigate(["shipyard/shipments/detail/" + e[0].shipmentHeaderId]);
      },
     error: (err) => {
      this.loading.next(false);
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Error. Please try again',
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
     }
   });
  }

  restrictNumeric(event) {
    if (event.which === 45) return false;
  }

  clearSearch() {
    this.searchInput.setValue("");
  }

  deleteItem(data: any) {
    this.clearSearch();
    this.skusToAddToShipment.forEach((res, index) => {
      if (data.sku.Sku == res.sku.Sku) {
        this.skusToAddToShipment.splice(index, 1);
        this.setSearch();
      }
    });
    this.selectedSKUs.forEach((res, index) => {
      if (data.sku == res.sku) {
        this.selectedSKUs.splice(index, 1);
      }
    });
    if(this.skusToAddToShipment.length == 0){
      this.actions[0].isDisabled = true; 
      this.actions[1].isDisabled = true;
      this.planShipmentForm.get('ShipmentType').enable();
     }
    this.gridActionsService.deselectRow(data);
  }

  importBulk() {
    this.close();
    this.dialog
      .open(AddSkuDialogComponent, {
        width: "720px",
        data: {
          importBulk: true,
          isCreateShipment: true,
          shipmentTypeId : this.planShipmentForm.getRawValue().ShipmentType,
          selectedSKUs: this.selectedSKUs,
        },
      })
      .afterClosed()
      .subscribe((e: { sku: string; qty: number }[]) => {
      });
  }

  createNewWarehouse(type: any) {
    this.dialogRef.close({ type });
  }

  loadSku(sku: any) {
    if (this.skusToAddToShipment.some((b) => b.sku.Sku === sku.sku.Sku)) {
      this.skusToAddToShipment.forEach((item, index) => {
        if (sku.sku.Sku === item.sku.Sku) {
          item.qty = item.qty + sku.qty;
          this.cdr.detectChanges();
        }
      });
    } else this.skusToAddToShipment.push(sku);
    if(this.skusToAddToShipment.length != 0){  
      this.actions[0].isDisabled = false; 
      this.actions[1].isDisabled = false;
      this.planShipmentForm.get('ShipmentType').disable();
    }
  }

  private setSearch() {
    this.addToShipmentSkus$ = merge(this.searchInput.valueChanges).pipe(
      startWith(""),
      switchMap(() => of(this.skusToAddToShipment)),
      map((skus: any[]) => {
        if (!this.searchInput.value) {
          return skus;
        } else {
          return skus.filter((sku) => {
            return (
              sku.sku.Sku.toLowerCase().includes(
                this.searchInput.value.toLowerCase()
              ) ||
              (sku.sku.fnSku &&
                sku.sku.fnSku
                  .toLowerCase()
                  .includes(this.searchInput.value.toLowerCase())) ||
              (sku.sku.Asin &&
                sku.sku.Asin.toLowerCase().includes(
                  this.searchInput.value.toLowerCase()
                )) ||
              (sku.sku.Title &&
                sku.sku.Title.toLowerCase().includes(
                  this.searchInput.value.toLowerCase()
                ))
            );
          });
        }
      })
    );
  }
}
